import { Font } from './types';

const BASE_URL = 'https://www.googleapis.com/webfonts/v1/webfonts';

interface FontResponse {
	kind: string;
	items: Font[];
}
const API_KEY = process.env.REACT_APP_GOOGLE_FONTS_API_KEY;

let loadedFonts: { [fontName: string]: boolean } = {};

let loadedGoogleFonts: null | string[] = null;

export const isFontLoaded = (font: string) => !!loadedFonts[font];

export const setFontLoaded = (font: string) => (loadedFonts[font] = true);

export const getGoogleFonts = async () => {
	if (!!loadedGoogleFonts) return loadedGoogleFonts;
	try {
		const response = await fetch(`${BASE_URL}?key=${API_KEY}`);
		const result: FontResponse = await response.json();
		const filteredFonts = result.items.filter((item) => item.category !== 'handwriting');
		const fontFamilyNames: string[] = filteredFonts.map((item) => item.family);
		loadedGoogleFonts = fontFamilyNames;
		return fontFamilyNames;
	} catch (e) {
		return [];
	}
};
